import React from "react";
import plus from "../images/plus.svg";
import upload from "../images/upload.svg";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
export default function Showupload() {
  const navigate = useNavigate();
  const toEdit = () => navigate("/dashboard/editing");
  const mousedown = (e) => (e.target.style.backgroundColor = "rgb(54, 54, 71)");
  const mouseup = (e) => (e.target.style.backgroundColor = "transparent");
  return (
    <>
      <center className="mt-5">
        <div
          onClick={toEdit}
          onMouseDown={mousedown}
          onMouseUp={mouseup}
          className="imgPlus"
        >
          <img src={plus} width="50%" alt="plus" />
        </div>
        <div>
          <button className="mt-5 uploadtext" onClick={toEdit}>
            Click To Upload <img src={upload} width="23px" alt="upload" />
          </button>
        </div>
      </center>
      <div className=" container mt-5 p-2">
        <div className="alert alert-primary  " role="alert">
          <h4 className="alert-heading">Note !</h4>
          <p>
            This webpage is only to manipulate madfilms production can create,
            delete,update youtube videos for <strong>MAD FILMS</strong> website.
          </p>
        </div>
      </div>
      <Footer/>
    </>
  );
}
